<template>
  <UiConfirm
    v-model="confirm.visible"
    :type="confirm.type"
    :title="confirm.title"
    :message="isStringMessage ? confirm.message : ''"
    :footer-hint="confirm.footerHint"
    :closeOnBackdropClick="false"
    :mouse-only="confirm.mouseOnly"
    :confirm-button-first="confirm.confirmButtonFirst"
    @confirm="handleConfirm"
    @cancel="handleCancel"
    :showCancelButton="confirm.showCancelButton"
    :confirmButtonText="confirm.confirmButtonText"
    :cancelButtonText="confirm.cancelButtonText || cancelButtonFallback"
  >
    <!-- message가 컴포넌트일 경우 동적으로 렌더링 -->
    <component v-if="!isStringMessage" :is="confirm.message" v-model="confirm.formData" />
  </UiConfirm>
</template>

<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useConfirmDialog } from '~/composables/useConfirmDialog';

const { t } = useI18n();
const { confirm, handleConfirm, handleCancel, showConfirm, showAlert, showConfirmDialog } = useConfirmDialog();

const cancelButtonFallback = computed(() => t('common.action.cancel'));

// message가 문자열인지 컴포넌트인지 판단
const isStringMessage = computed(() => typeof confirm.value.message === 'string');
</script>
